<template>
  <div>
    <div class="bg-transmaes-green flex justify-center px-3">
      <img class="w-40" src="../assets/images/transmaes_logo_big.svg" alt="">
    </div>
    <div class="flex mt-12 justify-center">
      <p class="text-2xl">{{$t('error_pageNotFound')}}.</p>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'TheNotFound',
  };

</script>
